'use strict';

angular.module('client.services').factory('ScoreService', ['api_server', '$resource',
  function (api_server, $resource) {
  return $resource(api_server + '/elements/scores/:element_id', {id: '@element_id'}, {
    get: {method: 'GET', isArray: true, params: {id: '@element_id'}},
    save: {method: 'POST', params: {id: '@element_id'}}
  });
}]);
